import React, { useState } from 'react'
import { Card, Button } from '../primitives';
import Modal from '../portals/Modal';
import NewPaymentMethod from '../popup/NewPaymentMethod';
import PaymentMethod from '../PaymentMethod';
import { catchErrorParse } from '../../ErrorUtility';
import { useAuthPost } from '../../hooks/useAxios';
import { useAuth } from '../../contexts/AuthContext';
import { useOutletContext } from "react-router-dom";
import { useTranslation } from '../../hooks/useTranslation';

export default function UpdatePaymentMethod({ paymentMethod, getCardData }) {

    const [isOpen, setIsOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const { post } = useAuthPost();
    const { url } = useAuth();
    const t = useTranslation();

    async function changePaymentMethod(paymentMethod, setError) {
        console.log('Change Payment Method: ', paymentMethod);
        const [result, error, errorCode, errorMessage] = await catchErrorParse(post, `${url}/webapp/payment-methods/update`, { payment_method: paymentMethod });
        if (error) {
            if (errorCode || errorMessage) {
                setError(errorMessage);
            } else {
                window.dispatchEvent(new CustomEvent('masterError', {
                    detail: {
                        code: errorCode,
                        message: errorMessage ? errorMessage : error.message
                    }
                }));
            }
            return false;
        }
        getCardData();
        return true;
    }

    const props = {
        setIsOpen,
        onSubmit: changePaymentMethod,
        loading,
        setLoading,
    };

    return (
        <>
        <Card className='margin-bottom'>
            <Card.Header>
                <h2>{t('Payment Method')}</h2>
            </Card.Header>
            <Card.Body>
                {paymentMethod ? <PaymentMethod paymentMethod={paymentMethod} /> : <h3>{t('You have no payment method.')}</h3>}
                <Button 
                    onClick={() => setIsOpen(true)}
                    className="submit settings"
                >
                    {t('Update Payment Method')}
                </Button>
            </Card.Body>
        </Card>
        <Modal 
            open={isOpen}
            onClickOutside={() => setIsOpen(false)}
            lock={loading}
        >
            <NewPaymentMethod {...props} />
        </Modal>
        </>
    )
}